import { InputField, InputSelectComboField } from 'lib/iterable-hook-form/FormField';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormField } from 'ui/formField';
import { JourneyTestingFormSchemaType } from './JourneyTestingModalFormProvider';
import { TEST_USER, TEST_USER_TYPE, TestUserType } from './constants';

const TEST_USER_OPTIONS = [
  { id: 'email-option', label: 'Email', value: TestUserType.Email },
  { id: 'user-id-option', label: 'User ID', value: TestUserType.UserId },
];

type Props = {
  /** Whether the project is uuid based */
  isUuidBased: boolean;
};

export const TestUser = ({ isUuidBased }: Props) => {
  const {
    formState: { errors },
  } = useFormContext<JourneyTestingFormSchemaType>();

  const [testUserType] = useWatch<JourneyTestingFormSchemaType>({
    name: [TEST_USER_TYPE],
  });

  if (!isUuidBased) {
    return (
      <FormField errorText={errors[TEST_USER]?.message} hasError={!!errors[TEST_USER]}>
        <InputField name={TEST_USER} placeholder="Enter user email" type="email" />
      </FormField>
    );
  }

  return (
    <FormField errorText={errors[TEST_USER]?.message} hasError={!!errors[TEST_USER]}>
      <InputSelectComboField
        name={TEST_USER}
        selectFieldName={TEST_USER_TYPE}
        id="input-select-combo"
        options={TEST_USER_OPTIONS}
        placeholder={`Enter ${testUserType === TestUserType.Email ? 'email' : 'user id'}`}
        width="100%"
        hasFilter={false}
      />
    </FormField>
  );
};
